/**
 * Calls a callback the untyped code called without checking that it exists. When it is missing, the call throws
 * the browser's TypeError ("<callee> is not a function") from a plain call of a local, as the untyped call did, so
 * the message keeps its shape (the bundle names the callee).
 */
const callUnchecked = <TArgs extends unknown[]>(
  callback: ((...args: TArgs) => unknown) | undefined,
  ...args: TArgs
): void => {
  // An empty array's first element is typed as present (no noUncheckedIndexedAccess): this is the unchecked call.
  const callbacks = callback ? [callback] : [];
  const [unchecked] = callbacks;
  unchecked(...args);
};

export default callUnchecked;
